import { render, staticRenderFns } from "./GameCardList.vue?vue&type=template&id=9db0d564&scoped=true"
import script from "./GameCardList.vue?vue&type=script&lang=js"
export * from "./GameCardList.vue?vue&type=script&lang=js"
import style0 from "./GameCardList.vue?vue&type=style&index=0&id=9db0d564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db0d564",
  null
  
)

export default component.exports